/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./VIPRCatDataItem',
	'./VIPRFormatter'
], function(_, VIPRCatDataItem, VIPRFormatter) {

	// implements ICatDataItem based on a continuous data item
	class VIPRCatContDataItem extends VIPRCatDataItem {
		constructor(resultItem, context) {
			super(resultItem, context);

			this.formatter = new VIPRFormatter(this.context.index.dataitem, 0, this.context);
			this.postProcessing();
		}

		destroy() {
			this.formatter = null;
			super.destroy();
		}

		getType() {
			return 'cont';
		}

		getFormatter() {
			return this.formatter;
		}

		postProcessing(){
			var index = this.context.index.dataitem;
			var subType = this.dataset.slots[index].getDefinition().getSubType();
			if (subType && subType === 'latitude' || subType ==='longitude') {
				for (let index = 0; index < this.resultItem.getRowCount(); index++) {
					const row = this.resultItem.getValue(index);
					if (row[0].hasOwnProperty('label') && row[0].hasOwnProperty('value') && (row[0].label !== row[0].value)){
						row[0].value = row[0].label;
					}
				}
			}
		}

		getItemClass() {
			return null;
		}

		getDomain() {
			return null;
		}
	}

	return VIPRCatContDataItem;
});